import React, { useEffect, useState } from 'react';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';

function ProdutoFormulario({ botao, eventoTeclado, cadastrarProduto, obj, alterarProduto, remover, copiarComoPai, criarVariacaoCor, produtos, mostrarMensagem, handleImageChange, variacoes = [], carregarVariacoes }) {
    const [filhos, setFilhos] = useState([]);

    useEffect(() => {
        if (obj && carregarVariacoes) {
            // Se o objeto atual for uma variação (filho), usar parentProductId (ou aliases) para carregar as variações do pai
            const parentId = (obj.parentProductId !== undefined && obj.parentProductId !== null)
                ? obj.parentProductId
                : (obj.parentId !== undefined && obj.parentId !== null)
                    ? obj.parentId
                    : (obj.idProduto || obj.id || null);
            console.log('[DEBUG] ProdutoFormulario - obj ao abrir modal:', obj);
            console.log('[DEBUG] ProdutoFormulario - parentId calculado:', parentId);
            if (parentId) carregarVariacoes(parentId);
        }
    }, [obj, carregarVariacoes]);

    useEffect(() => {
        setFilhos(Array.isArray(variacoes) ? variacoes : []);
        const arr = Array.isArray(variacoes) ? variacoes : [];
        console.log('[DEBUG] ProdutoFormulario - variacoes recebidas:', arr);
        setFilhos(arr);
    }, [variacoes]);

    // Safety check to ensure obj is not undefined
    if (!obj) {
        return <div>Carregando...</div>;
    }

    const handleVariacaoSelect = (e) => {
        const val = e.target.value;
        const selecionado = filhos.find(f => String(f.idProduto || f.id) === String(val));
        if (!selecionado) return;

        // Preencher campos do formulário com os dados da variação selecionada
        const campos = ['nomeModelo', 'marca', 'referencia', 'cor', 'status', 'idProduto', 'parentProductId'];
        campos.forEach(campo => {
            if (eventoTeclado) {
                const event = { target: { name: campo, value: selecionado[campo] ?? '' } };
                eventoTeclado(event);
            }
        });
    };

    return (
        <form>
            <div className="modal-form-field">
                <input
                    type="text"
                    value={obj?.nomeModelo || ''}
                    onChange={eventoTeclado}
                    name='nomeModelo'
                    placeholder="Nome do Modelo"
                    className='form-control'
                />
            </div>

            <div className="modal-form-field">
                <input
                    type="text"
                    value={obj?.marca || ''}
                    onChange={eventoTeclado}
                    name='marca'
                    placeholder="Marca"
                    className='form-control'
                />
            </div>

            <div className="modal-form-field">
                <input
                    type="text"
                    value={obj?.referencia || ''}
                    onChange={eventoTeclado}
                    name='referencia'
                    placeholder="Referência"
                    className='form-control'
                />
            </div>

            <div className="modal-form-field">
                <input
                    type="text"
                    value={obj?.cor || ''}
                    onChange={eventoTeclado}
                    name='cor'
                    placeholder="Cor"
                    className='form-control'
                />
            </div>

            {/* Select de variações (pai + filhos) - oculto no modo Cadastrar */}
            {!botao && (
                <div className="modal-form-field">
                    <label htmlFor="selectVariacao" style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Variações</label>
                    <select id="selectVariacao" onChange={handleVariacaoSelect} className='form-control'>
                        <option value="">-- Selecionar variação --</option>
                        {filhos && filhos.map((f) => (
                            <option key={f.idProduto || f.id} value={f.idProduto || f.id}>
                                {f.nomeModelo} {f.referencia ? `- ${f.referencia}` : ''} {f.cor ? `(${f.cor})` : ''}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            <div className="modal-form-field">
                <input
                    type="text"
                    value={obj?.status || ''}
                    onChange={eventoTeclado}
                    name='status'
                    placeholder="Status"
                    className='form-control'
                />
            </div>

            <div className="modal-form-field">
                <label htmlFor="imagemProduto" className="form-label" style={{ 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontWeight: '600', 
                    color: '#333',
                    fontSize: '14px'
                }}>
                    Imagem do Produto
                </label>
                <input
                    type="file"
                    onChange={handleImageChange}
                    name='imagemProduto'
                    id="imagemProduto"
                    className='form-control'
                    accept="image/*"
                />
                {obj?.image && (
                    <div style={{ 
                        marginTop: '4px', 
                        fontSize: '12px', 
                        color: '#666',
                        fontStyle: 'italic'
                    }}>
                        ✓ Imagem selecionada
                    </div>
                )}
            </div>

            {/* Prévia da imagem */}
            {obj?.image ? (
                <div className="modal-form-field">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        marginBottom: '8px'
                    }}>
                        <label className="form-label" style={{ 
                            fontWeight: '600', 
                            color: '#333',
                            fontSize: '14px',
                            margin: '0'
                        }}>
                            Prévia da Imagem
                        </label>
                        <button
                            type="button"
                            onClick={() => {
                                // Limpar a imagem do estado
                                if (eventoTeclado) {
                                    const event = {
                                        target: {
                                            name: 'image',
                                            value: ''
                                        }
                                    };
                                    eventoTeclado(event);
                                }
                            }}
                            style={{
                                background: '#ff6b6b',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '4px 8px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#ff5252';
                                e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#ff6b6b';
                                e.target.style.transform = 'scale(1)';
                            }}
                        >
                            Remover
                        </button>
                    </div>
                    <div 
                        style={{
                            border: '2px dashed #d0d0d0',
                            borderRadius: '12px',
                            padding: '15px',
                            textAlign: 'center',
                            backgroundColor: '#f9f9f9',
                            minHeight: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <img
                            src={obj.image}
                            alt="Prévia do produto"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '180px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease'
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                            onLoad={(e) => {
                                e.target.style.transform = 'scale(1)';
                            }}
                        />
                        <div 
                            style={{ 
                                display: 'none',
                                color: '#666',
                                fontSize: '14px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                gap: '8px'
                            }}
                        >
                            <div style={{ fontSize: '24px', opacity: '0.5' }}>📷</div>
                            <div>Erro ao carregar imagem</div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="modal-form-field">
                    <label className="form-label" style={{ 
                        fontWeight: '600', 
                        color: '#333',
                        fontSize: '14px',
                        marginBottom: '8px',
                        display: 'block'
                    }}>
                        Prévia da Imagem
                    </label>
                    <div 
                        style={{
                            border: '2px dashed #d0d0d0',
                            borderRadius: '12px',
                            padding: '15px',
                            textAlign: 'center',
                            backgroundColor: '#f9f9f9',
                            minHeight: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <div style={{ 
                            color: '#999',
                            fontSize: '14px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <div style={{ fontSize: '48px', opacity: '0.3' }}>📷</div>
                            <div>Nenhuma imagem selecionada</div>
                            <div style={{ fontSize: '12px', opacity: '0.7' }}>
                                Selecione uma imagem acima para ver a prévia
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="modal-buttons">
                {botao ? (
                    <div className="modal-actions">
                        <PermissionGate permissions={["fichaTecnicaItensCadastrar"]}>
                            <button type="button" onClick={cadastrarProduto} className='modal-button modal-button-primary'>
                                Cadastrar
                            </button>
                        </PermissionGate>
                    </div>
                ) : (
                    <div className="modal-actions">
                        <PermissionGate permissions={["fichaTecnicaItensAlterar"]}>
                            <button type="button" onClick={alterarProduto} className='modal-button modal-button-warning'>
                                Alterar
                            </button>
                        </PermissionGate>

                        <PermissionGate permissions={["fichaTecnicaItensRemover"]}>
                            <button type="button" onClick={remover} className='modal-button modal-button-danger'>
                                Remover
                            </button>
                        </PermissionGate>
                        <PermissionGate permissions={["fichaTecnicaItensCopiarItens"]}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                <button type="button" onClick={() => copiarComoPai()} className='modal-button modal-button-secondary'>
                                    Copiar como Pai
                                </button>
                            </div>
                        </PermissionGate>
                    </div>
                )}
            </div>
        </form>
    );
}

export default ProdutoFormulario;